import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  // console.log("isAuthenticated", authService.isAuthenticated());
  const isAuthenticated = JSON.parse(localStorage.getItem("loginObject") || "{}").token;

  if (isAuthenticated) {
    return true; // ✅ allow navigation
  }

  return router.createUrlTree(['/auth/login']); // ✅ redirect properly
};